// extracted by mini-css-extract-plugin
export default {"container":"ImageBox_container__d8fCX","img_structure":"ImageBox_img_structure__CDrtk","image":"ImageBox_image__LdPgJ","overlay":"ImageBox_overlay__PVXgZ"};